import React from 'react';
import {Route} from 'react-router-dom';
import AsyncPage from './async';

export default [
  <Route
    key="/business/products/ai-face-analyzer"
    path="business/products/ai-face-analyzer"
    element={<AsyncPage />}
  />,
];
